import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'password-recovery',
    loadChildren: () => import('./pages/password-recovery/password-recovery.module').then(m => m.PasswordRecoveryPageModule)
  },
  {
    path: 'course',
    loadChildren: () => import('./pages/course/course.module').then(m => m.CoursePageModule)
  },
  {
    path: 'course/create',
    loadChildren: () => import('./pages/course/course-edit/course-edit.module').then(m => m.CourseEditPageModule)
  },
  {
    path: 'course/update/:id',
    loadChildren: () => import('./pages/course/course-edit/course-edit.module').then(m => m.CourseEditPageModule)
  },
  {
    path: 'module/create/:idCurse',
    loadChildren: () => import('./pages/module/module.module').then(m => m.ModulePageModule)
  },
  {
    path: 'module/update/:idModule',
    loadChildren: () => import('./pages/module/module.module').then(m => m.ModulePageModule)
  },
  {
    path: 'class/create/:idModule',
    loadChildren: () => import('./pages/class/class.module').then(m => m.ClassPageModule)
  },
  {
    path: 'class/update/:idClass',
    loadChildren: () => import('./pages/class/class.module').then(m => m.ClassPageModule)
  },

  {
    path: 'review',
    loadChildren: () => import('./pages/review/review.module').then(m => m.ReviewPageModule)
  },
  {
    path: 'evaluations',
    loadChildren: () => import('./pages/evaluations/evaluations.module').then(m => m.EvaluationsPageModule)
  },
  {
    path: 'evaluation/create/:idModule',
    loadChildren: () => import('./pages/evaluations/evaluations-edit/evaluations-edit.module').then(m => m.EvaluationsEditPageModule)
  },
  {
    path: 'evaluation/update/:idEvaluation',
    loadChildren: () => import('./pages/evaluations/evaluations-edit/evaluations-edit.module').then(m => m.EvaluationsEditPageModule)
  },
  {
    path: 'question/create/:idEvaluation',
    loadChildren: () => import('./pages/questions/questions.module').then(m => m.QuestionsPageModule)
  },
  {
    path: 'question/update/:idQuestion',
    loadChildren: () => import('./pages/questions/questions.module').then(m => m.QuestionsPageModule)
  },
  {
    path: 'alternative/create/:idQuestion',
    loadChildren: () => import('./pages/alternatives/alternatives.module').then(m => m.AlternativesPageModule)
  },
  {
    path: 'alternative/update/:idAlternative',
    loadChildren: () => import('./pages/alternatives/alternatives.module').then(m => m.AlternativesPageModule)
  },
  {
    path: 'online-class',
    loadChildren: () => import('./pages/online-class/online-class.module').then(m => m.OnlineClassPageModule)
  },
  {
    path: 'online-class/create',
    loadChildren: () => import('./pages/online-class/online-class-edit/online-class-edit.module').then(m => m.OnlineClassEditPageModule)
  },
  {
    path: 'online-class/update/:idOnlineClass',
    loadChildren: () => import('./pages/online-class/online-class-edit/online-class-edit.module').then(m => m.OnlineClassEditPageModule)
  },
  {
    path: 'students',
    loadChildren: () => import('./pages/student/student.module').then(m => m.StudentPageModule)
  },
  {
    path: 'student/create',
    loadChildren: () => import('./pages/student/student-edit/student-edit.module').then(m => m.StudentEditPageModule)
  },
  {
    path: 'student/update/:idUser',
    loadChildren: () => import('./pages/student/student-edit/student-edit.module').then(m => m.StudentEditPageModule)
  },
  {
    path: 'comments',
    loadChildren: () => import('./pages/comments/comments.module').then(m => m.CommentsPageModule)
  },
  {
    path: 'comment/reply/:idComment',
    loadChildren: () => import('./pages/comments/comment-edit/comment-edit.module').then(m => m.CommentEditPageModule)
  },
  {
    path: 'groups',
    loadChildren: () => import('./pages/groups/groups.module').then(m => m.GroupsPageModule)
  },
  {
    path: 'group/create',
    loadChildren: () => import('./pages/groups/group-edit/group-edit.module').then(m => m.GroupEditPageModule)
  },
  {
    path: 'group/update/:idGroup',
    loadChildren: () => import('./pages/groups/group-edit/group-edit.module').then(m => m.GroupEditPageModule)
  },
  {
    path: 'group/manage/:type/:idGroup',
    loadChildren: () => import('./pages/groups/group-manage/group-manage.module').then(m => m.GroupManagePageModule)
  },
  {
    path: 'group/manage/link/:type/:idGroup',
    loadChildren: () => import('./pages/groups/group-manage/manage-edit/manage-edit.module').then(m => m.ManageEditPageModule)
  },
  {
   path: 'report-estudent/:idCurse/:idGroup',
   loadChildren: () => import('./pages/boletim-estudent/boletim-estudent.module').then(m => m.BoletimEstudentPageModule)
 },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
